import { useEffect, useMemo, useState } from "react";
import { listEffectiveServiceOfferings } from "@/lib/service/client";
import type { EffectiveServiceOffering } from "@/lib/service/types";
import { resolveQuotableServiceOfferingForProductType } from "@/lib/opportunity/serviceOpportunityMatch";

/** Loads effective quotable offerings and resolves whether this opp is a service sale. */
export function useOpportunityServiceOfferingMatch(productType: string) {
  const [offerings, setOfferings] = useState<EffectiveServiceOffering[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void listEffectiveServiceOfferings({ quotable_only: true }).then((res) => {
      if (cancelled) return;
      setOfferings(res.ok ? res.data.offerings : []);
      setLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const matchedOffering = useMemo(
    () => resolveQuotableServiceOfferingForProductType(offerings, productType),
    [offerings, productType]
  );

  return { matchedOffering, loaded };
}
